<div class="engie-home">
    <div class="engie-accesos">
          <div class="container">
                <div class="row items-accesos">
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && esAdministrador">
                        <a [routerLink]="['/seguridad']">
                            <img src="./assets/img/home/people.svg"/>
                            <h5>Gestión de usuarios</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && esAdministrador">
                        <a [routerLink]="['/configuracion/contratistas']">
                            <img src="./assets/img/home/safety.svg"/>
                            <h5>Empresas Contratistas</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && esAdministrador">
                        <a [routerLink]="['/configuracion/documentos']">
                            <img src="./assets/img/home/edit.svg"/>
                            <h5>Documentos Requeridos</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && (esSolicitante)">
                        <a [routerLink]="['/solicitudes-engie']">
                            <img src="./assets/img/home/document.svg"/>
                            <h5>Mis solicitudes</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && (esSolicitante)">
                        <a [routerLink]="['/solicitudes-engie', 'registrar']">
                            <img src="./assets/img/home/edit.svg"/>
                            <h5>Registrar solicitud</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioContratista">
                        <a [routerLink]="['/solicitudes-contratista']">
                            <img src="./assets/img/home/safety.svg"/>
                            <h5>Mis Solicitudes</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && (esRevisor)">
                        <a [routerLink]="['/solicitudes', 'revision']">
                            <img src="./assets/img/home/document.svg"/>
                            <h5>Bandeja Revisor</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && (esSupervisor)">
                        <a [routerLink]="['/solicitudes', 'aprobacion']">
                            <img src="./assets/img/home/document.svg"/>
                            <h5>Bandeja Aprobador</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && (esAdministradorSSO)">
                        <a [routerLink]="['/solicitudes', 'administracion']">
                            <img src="./assets/img/home/document.svg"/>
                            <h5>Bandeja Administrador</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && (esSupervisor)">
                        <a [routerLink]="['/solicitudes', 'pendientes-acceso']">
                            <img src="./assets/img/home/user.svg"/>
                            <h5>Autorizar Accesos</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && esCoordinador">
                        <a [routerLink]="['/inducciones/programacion']">
                            <img src="./assets/img/home/equipos.svg"/>
                            <h5>Programar Inducciones</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && esCoordinador">
                        <a [routerLink]="['/inducciones/resultados/registrar']">
                            <img src="./assets/img/home/edit.svg"/>
                            <h5>Resultados Inducción</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioContratista">
                        <a [routerLink]="['/inducciones']">
                            <img src="./assets/img/home/equipos.svg"/>
                            <h5>Consultar Inducciones</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && (esCoordinador || esSupervisor || esCoordinador || esVigilante || esAdministradorSSO)">
                        <a [routerLink]="['/inducciones/personas']">
                            <img src="./assets/img/home/equipos.svg"/>
                            <h5>Consultar Inducciones</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioEngie && (esAdministrador || esSolicitante || esSupervisor || esCoordinador || esVigilante || esAdministradorSSO)">
                        <a [routerLink]="['/vigilancia/accesos']">
                            <img src="./assets/img/home/people.svg"/>
                            <h5>Consulta Accesos</h5>
                        </a>
                    </div>
                    <div class="box" *ngIf="isAuthenticated && idTipoUsuario === usuarioContratista">
                        <a [routerLink]="['/acceso-personal/por-contratista']">
                            <img src="./assets/img/home/people.svg"/>
                            <h5>Consultar Accesos</h5>
                        </a>
                    </div>
                </div>
          </div>
    </div>

</div>
